import { render, staticRenderFns } from "./DanioCerebralPorTrauma.vue?vue&type=template&id=0e5b7172"
import script from "./DanioCerebralPorTrauma.vue?vue&type=script&lang=js"
export * from "./DanioCerebralPorTrauma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports